<template>
    <div class="rodemap">
        <div class="mask05"></div>
        <QuestionSelect :data="data" @jump="jump" @finish="finish"></QuestionSelect>
    </div>
</template>

<script>
    //script
    import Tools from "../../../scripts/tools";
    import {gsap} from "gsap";
    //Global
    import Global from "../../../scripts/Global";
    import QuestionSelect from "../../cmp/questionSelect";

    export default {
        data() {
            return {
                data: {
                    headTipImg: "cv-04",
                    headTipTxt: "是8位哦，从雍正开始，历任皇帝都曾在此居住过。",
                    headTipPathTxt: "前往养性斋 >>",
                    headTipPath: "/rodemap/ytx/03",

                    qText: "你知道清代有多少位皇帝先后居住在养心殿吗？",
                    errText: "你知道清代有多少位皇帝先后居住在养心殿吗？",
                    sideImg: "杨",
                    sideCfg: {
                        transform: "scale(0.6)",
                        bottom: "0rem",
                        left: "-1rem"
                    },
                    answerArr: [
                        {
                            txt: "七 位"
                        },
                        {
                            txt: "八 位",
                            right: true
                        },
                        {
                            txt: "九 位"
                        }
                    ]
                }
            };
        },
        components: {
            QuestionSelect
        },
        created() {
            Global.startPlay("ytx", "scene2_1");
        },
        computed: {},
        methods: {
            jump(event) {
                if (event) {
                    Global.curr = {
                        ...this.data,
                        headTipImg: "",
                        headTipTxt: "真厉害，就是8位，我们去养性斋看看吧",
                        headTipPath: "/rodemap/ytx/03",
                        headTipPathTxt: "前往养性斋 >>",
                        ybtxt: "",
                        bg: "琼苑西门",
                        textCfg: {
                            "text-align": "center"
                        }
                    };
                    Global.yubi.ytx.b1 = true;
                    this.$router.replace("/yu");
                } else {
                    this.$router.replace("/rodemap/ytx/03");
                }
                console.log(event, "event");
            },
            finish(event) {
                if (event) {
                    Global.curr.headTipImg='cv-04'
                    Global.startPlay("ytx", "scene2");
                } else {
                    Global.startPlay("ytx", "scene3");
                }
            }
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/琼苑西门.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
